export default __webpack_public_path__ + "media/images/svg/ico-pay-1cc58791ef55d9c79775b74ce02c756e.svg";